import { SyntheticEvent, useState, useEffect } from 'react';
import cls from 'classnames';
import { Tooltip } from '@quicktools/shared-components/components/core/Tooltip';
import { fontifyString } from '@quicktools/shared-components/utils/fonts';

import getFontFontId from '../../utils/common/getFontId';

import FontInfo from './FontInfo';
import useStyles from './styles';
import { FontRowProps } from './types';

const MAX_HOVER_COUNT = 3;
let hoverCount = 0;

export function AsciiFontRow({
  font,
  copyText,
  rawText,
  isActive,
  isCopied,
  displayCategoryName,
}: FontRowProps) {
  const [fontifiedText, setFontifiedText] = useState('');
  const [tooltipVisible, setTooltipVisible] = useState(false);
  const [copiedTooltipVisible, setCopiedTooltipVisible] = useState(false);
  const [tooltipLeft, setToolTipLeft] = useState(0);
  const [tooltipTop, setToolTipTop] = useState(0);
  const classes = useStyles({ tooltipLeft, tooltipTop });

  const onClick = async (e: any) => {
    setToolTipLeft(e.nativeEvent.layerX);
    setToolTipTop(e.nativeEvent.layerY);
    const selection = window.getSelection().toString();

    if (!selection) {
      const copied = copyText({ font, fontifiedText });
      if (copied) {
        setCopiedTooltipVisible(true);
        setTimeout(() => {
          setCopiedTooltipVisible(false);
        }, 2500);
      }
    }
  };

  const onMouseEnter = () => {
    if (hoverCount < MAX_HOVER_COUNT) {
      setTooltipVisible(true);
      hoverCount++;
    }
  };

  const onMouseLeave = () => {
    tooltipVisible && setTooltipVisible(false);
  };

  const onButtonClick = (e: SyntheticEvent<HTMLButtonElement>) => {
    e.stopPropagation();

    copyText({ font, fontifiedText });
  };

  useEffect(() => {
    (async () => {
      const text = await fontifyString(font, rawText);

      setFontifiedText(text as string);
    })();
  }, [rawText]);

  return (
    <div
      id={getFontFontId(font)}
      onMouseEnter={onMouseEnter}
      onMouseLeave={onMouseLeave}
      className={cls(classes.root, {
        active: isActive,
      })}
      key={font.name}
      onClick={onClick}
    >
      {copiedTooltipVisible && (
        <Tooltip color="magenta" arrowType="down" className={classes.copiedTooltip}>
          Copied!
        </Tooltip>
      )}
      <div>
        <p className={classes.asciiPre}>{fontifiedText}</p>
        <FontInfo font={font} displayCategoryName={displayCategoryName} />
      </div>
      {tooltipVisible && (
        <div
          className={cls(classes.tooltip, 'tooltip-icon', {
            active: isActive,
          })}
        >
          <Tooltip arrowType="up">Click to copy!</Tooltip>
        </div>
      )}
      <div className={classes.asciiBtnContainer}>
        <button
          className={cls(classes.copyButton, 'copy-button', {
            active: isActive,
          })}
          onClick={onButtonClick}
        >
          {isCopied ? 'Copied!' : 'Copy'}
        </button>
      </div>
    </div>
  );
}
